import { ReactComponent as IconSvg } from 'approot/shared/inline-svg/activity-builder/icon_square.svg';
import Icon, { IconProps } from '../../icons/icon';

const IconSquare = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconSquare;
